
import { Button } from "@/components/ui/button";
import { Undo2 } from "lucide-react";

interface HabitCardActionsProps {
  isCompleted: boolean;
  completedDays: number;
  onComplete: () => void;
  onRevert?: () => void;
  onDuplicate?: () => void;
}

export const HabitCardActions = ({
  isCompleted,
  completedDays,
  onComplete,
  onRevert,
  onDuplicate
}: HabitCardActionsProps) => {
  return (
    <div className="flex items-center space-x-2 ml-auto">
      {completedDays > 0 && onRevert && (
        <Button
          onClick={onRevert}
          variant="outline"
          size="icon"
          className="h-8 w-8 border-2 hover:border-primary/50"
        >
          <Undo2 className="w-4 h-4" />
        </Button>
      )}
      {isCompleted ? (
        <Button
          onClick={onDuplicate}
          variant="secondary"
          className="bg-primary hover:bg-primary-dark text-white"
        >
          Start Again
        </Button>
      ) : (
        <Button
          onClick={onComplete}
          variant="secondary"
          className="bg-primary hover:bg-primary-dark text-white"
          disabled={isCompleted}
        >
          Complete
        </Button>
      )}
    </div>
  );
};
